// Widget Scripts
import 'animate.css';
import menuPanel from './js/menuPanel';
import swiperWidget from './js/widgets/swiperWidget';
import cardWidgetSEOText from './js/widgets/cardWidgetSEOText';
import cardWidgetImageCards from './js/widgets/cardWidgetImageCards';
import cardWidgetMegaRidePass from './js/widgets/cardWidgetMegaRidePass';
import cssSponsors from './js/widgets/cssSponsors';
import disneyIceModal from './js/disneyIcePopup';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    swiperWidget();
    cardWidgetSEOText();
    cardWidgetImageCards();
    cssSponsors();
  });
}

$(document).ready(function() {
  menuPanel();
  cardWidgetMegaRidePass();

  // if (window.location.pathname.includes('/events/2024/disney-on-ice')) {
  //   disneyIceModal();
  // }

  if($(body).hasClass('disneyEvent')){
    disneyIceModal();
  }

});